// Accessor Keys. Some are based on the "ReducedComparison" type
export enum COMPARISON_TABLE_COLUMNS_KEYS {
  ACTIONS = 'actions',
  CONTACTS = 'contacts',
  LAST_MODIFIED = 'lastRunAt',
  NAME = 'name',
  SAVED_TO = 'savedTo',
  SHARED_WITH = 'sharedWith',
}

export enum ExportComparisonRequirements {
  ARE_PORTFOLIOS_IN_RANGE = 'arePortfoliosInRange',
  ARE_RECOMMENDED_PORTFOLIOS_IN_RANGE = 'areRecommendedPortfoliosInRange',
  IS_COMPARISON_HAS_RISK_PROFILE = 'isComparisonHasRiskProfile',
  IS_EACH_PORTFOLIOS_HAS_RISK_PROFILE = 'isEachPortfoliosHasRiskProfile',
  IS_RECOMMENDED_PORTFOLIOS_HAS_RISK_PROFILE = 'isRecommendedPortfoliosHasRiskProfile',
  IS_EACH_PORTFOLIOS_CURRENT_OR_RECOMMENDED = 'isEachPortfoliosCurrentOrRecommended',
  RECOMMENDED_PORTFOLIO_CANNOT_EXCEED_CURRENT_OFF_SHELF = 'recommendedPortfolioCannotExceedCurrentOffShelf',
  RECOMMENDED_PORTFOLIO_CANNOT_CONTAIN_OFF_SHELF = 'recommendedPortfolioCannotContainOffShelf',
}

export enum ProposalExportRequirementsModalDisplayMode {
  ERROR = 'error',
  HIDDEN = 'hidden',
  WARNING = 'warning',
  SECURITY_WARNING = 'security_warning',

  MISSING_COMPARISON_RISK_PROFILE = 'missing_comparison_risk_profile',
  MISSING_PORTFOLIO_RISK_PROFILE = 'missing_portfolio_risk_profile',
  MISSING_RECOMMENDED_PORTFOLIOS_RISK_PROFILE = 'missing_recommended_portfolios_risk_profile',
  PORTFOLIO_RISK_PROFILE_OUTSIDE_RANGE = 'portfolio_risk_profile_outside_range',
  RECOMMENDED_PORTFOLIOS_OUTSIDE_RANGE = 'recommended_portfolios_outside_range',
  PORTFOLIO_NOT_CURRENT_OR_RECOMMENDED = 'portfolio_not_current_or_recommended',
  RECOMMENDED_PORTFOLIOS_EXCEEDS_CURRENT_OFF_SHELF = 'recommended_portfolios_exceeds_current_off_shelf',
  RECOMMENDED_PORTFOLIOS_CONTAINS_OFF_SHELF = 'recommended_portfolios_contains_off_shelf',
}

export enum COMPARISON_MODIFIED_ITEM_KEYS {
  UNALLOCATED_PORTFOLIO = 'unallocatedPortfolio',
  PLANNING_REMOVED = 'PLANNING_REMOVED',
}

export enum ComparisonNavigationTab {
  Performance = 'performance',
  IncomeStream = 'income-stream',
  RiskProfile = 'risk-profile',
  Markup = 'markup',
  HistoricalScenarios = 'historical-scenarios',
  TaxAnalysis = 'tax-analysis',
}
